import loadable from "@loadable/component";
import Loading from "../Components/Loading";

export const LandingLoadable = loadable(
  () => import("../Pages/Landing/Landing"),
  {
    fallback: <Loading />,
  }
);

export const Step0Loadable = loadable(() => import("../Pages/Step0/Step0"), {
  fallback: <Loading />,
});

export const StartWithPANLoadable = loadable(
  () => import("../Pages/PanInformation/StartWithPAN"),
  {
    fallback: <Loading />,
  }
);

export const ExistingClinetEmailMobileVerificationLoadable = loadable(
  () =>
    import(
      "../Pages/ExistingClinetEmailMobileVerification/ExistingClinetEmailMobileVerification"
    ),
  {
    fallback: <Loading />,
  }
);

export const AccountOpeningFeeLoadable = loadable(
  () => import("../Pages/ProductSelection/ProductSelection"),
  {
    fallback: <Loading />,
  }
);

export const DetailsFromKYCLoadable = loadable(
  () => import("../Pages/DetailsFromKYC/DetailsFromKYC"),
  {
    fallback: <Loading />,
  }
);

export const PLMAQuestionLoadable = loadable(
  () => import("../Pages/PLMAQuestion/PLMAQuestion"),
  {
    fallback: <Loading />,
  }
);

export const LinkBankAccountLoadable = loadable(
  () => import("../Pages/LinkBankAccount/LinkBankAccount"),
  {
    fallback: <Loading />,
  }
);

export const Stage7Loadable = loadable(() => import("../Pages/Step7/Stage7"), {
  fallback: <Loading />,
});
export const Stage8Loadable = loadable(() => import("../Pages/Step8/Stage8"), {
  fallback: <Loading />,
});

export const HeaderLoadable = loadable(() => import("../Main/Header"), {
  fallback: <Loading />,
});

export const DocumentUploadLoadable = loadable(
  () => import("../Pages/DocumentUpload/DocumentUpload"),
  {
    fallback: <Loading />,
  }
);

export const LivePhotoUploadLoadable = loadable(
  () => import("../Pages/Step5/LivePhotoUpload"),
  {
    fallback: <Loading />,
  }
);
